/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { type ReactNode, type SyntheticEvent, useState } from 'react';

import { Breadcrumbs, Card, CardContent, Paper } from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useContainer } from 'unstated-next';

import { TroubleshootingDetailErrorLogs } from './TroubleshootingDetailErrorLogs';
import { TroubleshootingDetailSettings } from './TroubleshootingDetailSettings';
import { TroubleshootingDetailTickets } from './TroubleshootingDetailTickets';
import AdminAuthContainer from '../../../AdminAuthContainer';
import { TroubleshootingDetailErrorLogsProvider } from '../TroubleshootingDetailErrorLogsContext';

interface TabPanelProps {
    children?: ReactNode;
    dir?: string;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`class-detail-tabpanel-${index}`}
            aria-labelledby={`class-detail-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ mt: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `class-detail-tab-${index}`,
        'aria-controls': `class-detail-tabpanel-${index}`,
        value: index
    };
}

export const TroubleshootingDetail = () => {
    console.log('TroubleshootingDetail');
    const { t } = useTranslation('portal');
    const { authMode } = useContainer(AdminAuthContainer);
    const theme = useTheme();
    const startingTab = {
        customerSupport: 1
    };
    const [tabValue, setTabValue] = useState(startingTab[authMode] || 0);

    const handleTabChange = (event: SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Link to="/portal/troubleshooting">{t('troubleshooting')}</Link>
            </Breadcrumbs>
            <Paper elevation={0} sx={{ mt: 2 }}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label={t('portal:classes-page.class-detail-tabs')}
                >
                    <Tab label={t('portal:troubleshootings.tickets')} {...a11yProps(0)} />
                    <Tab label={t('portal:troubleshootings.errorlogs')} {...a11yProps(1)} />
                    <Tab label={t('portal:troubleshootings.settings')} {...a11yProps(2)} />
                </Tabs>
            </Paper>

            <TabPanel value={tabValue} index={0} dir={theme.direction}>
                <Card elevation={0} sx={{ overflow: 'visible', padding: 0 }}>
                    <CardContent>
                        <TroubleshootingDetailTickets />
                    </CardContent>
                </Card>
            </TabPanel>
            <TabPanel value={tabValue} index={1} dir={theme.direction}>
                <Card elevation={0} sx={{ overflow: 'visible', padding: 0 }}>
                    <CardContent>
                        <TroubleshootingDetailErrorLogsProvider>
                            <TroubleshootingDetailErrorLogs />
                        </TroubleshootingDetailErrorLogsProvider>
                    </CardContent>
                </Card>
            </TabPanel>
            <TabPanel value={tabValue} index={2} dir={theme.direction}>
                <Card elevation={0} sx={{ overflow: 'visible', padding: 0 }}>
                    <CardContent>
                        <TroubleshootingDetailSettings />
                    </CardContent>
                </Card>
            </TabPanel>
        </>
    );
};
